import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';
import { bulkAllowBroadcast } from 'features/permissions/actions';

export function* bulkAllowBroadcastSaga(action: ReturnType<typeof bulkAllowBroadcast>) {
  const { roles, audio, video } = action.payload;

  logger
    .remote({ action: true, tier: 1 })
    .info(
      `The user bulk allowed broadcast for roles=${roles.join(',')} with audio=${audio} and video=${video}`
    );

  yield call(SignalingSocket.send, {
    event: 'bulkAllowBroadcast',
    data: { roles, audio, video },
  });
}
